import React from 'react';
import OnboardingLayout from './OnboardingLayout';
import OnboardingStep2 from './step2';

export default class OnboardingStep2Page extends React.Component {
    render() {
        return (
            <OnboardingLayout currentStep={2} totalSteps={5}>
                <OnboardingStep2 />
            </OnboardingLayout>
        );
    }
}
